import { Link } from 'react-router-dom';
import { getPopularComics, getNewComics } from '@/mocks/comics';

export default function RankingSection() {
  const popularComics = getPopularComics(10);
  const newComics = getNewComics(10);

  return (
    <section className="py-10 md:py-14">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">最新更新</h2>
                <p className="text-sm text-foreground-500 mt-1">海量漫画持续更新中</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5" data-product-shop>
              {newComics.slice(0, 8).map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="group flex items-start gap-3 p-3 rounded-lg hover:bg-background-100 transition-colors duration-200"
                >
                  <div className="w-[72px] h-[100px] flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                      {comic.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                    <p className="text-xs text-primary-500 mt-1.5">{comic.latestChapter}</p>
                    <p className="text-[10px] text-foreground-400 mt-1">{comic.updateTime}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-background-100 rounded-xl p-5 sticky top-24">
              <div className="flex items-center justify-between mb-5">
                <h2 className="text-lg font-heading font-bold text-foreground-900">热门排行</h2>
                <div className="flex items-center gap-1.5">
                  <button className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap cursor-pointer">
                    总榜
                  </button>
                  <button className="px-3 py-1 rounded-full bg-transparent text-foreground-500 text-xs font-medium hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    周榜
                  </button>
                </div>
              </div>

              <div className="space-y-1">
                {popularComics.map((comic, index) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.id}`}
                    className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-background-200/70 transition-colors duration-200 group"
                  >
                    <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold flex-shrink-0 ${
                      index < 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-300 text-foreground-600'
                    }`}>
                      {index + 1}
                    </span>
                    <div className="w-9 h-12 flex-shrink-0 rounded overflow-hidden">
                      <img
                        src={comic.coverImage}
                        alt={comic.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                        {comic.title}
                      </h4>
                      <p className="text-[11px] text-foreground-500 mt-0.5">{comic.category} · {comic.author}</p>
                    </div>
                    <span className="text-xs text-accent-500 font-medium flex-shrink-0">{comic.rating}</span>
                  </Link>
                ))}
              </div>

              <Link
                to="/category/hanman"
                className="block w-full text-center mt-4 py-2.5 rounded-lg border border-background-300/60 text-sm text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-colors duration-200"
              >
                查看完整排行
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}